
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-partners",
      function () {
        return require("private-next-pages/contact-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-partners"])
      });
    }
  